import { IFacetResults, SearchableType } from '@/@types/client-api';
import { IContent } from '@/@types/cms';
import { FilterBlock } from '@/@types/content';

export type TitleSize = 'h6' | 'h5' | 'h4' | 'h3' | 'h2' | 'h1' | undefined;

export const facetGroupsToCheck = ['MyLibrary', 'MyProfile'];
export const facultyParams = ['FacultyMembers', 'ProgramsFromFirmsColleague'];
export enum BasicContentRowBlockType {
  Standard = 'standard',
  Faculty = 'faculty',
  Library = 'library'
}

export interface FilterBlockExtended extends FilterBlock {
  editorOverridesPositive?: IContent[];
  editorOverridesPositiveSearchValue?: string;
  editorOverridesNegative?: IContent[];
  editorExclusions?: IContent[];
}

export interface IContentWithCode extends IContent {
  code?: string;
  productCode?: string;
  parentProductCode?: string;
}

export interface ContainedCategory {
  id?: string;
  name?: string;
  description?: string;
}

export interface DataFilter {
  facetResults?: IFacetResults;
  searchResults?: {
    searchResultsItems?: Record<string, unknown>[];
  };
}

const ConvertedSearchableType = [
  'onDemandProgram',
  'onDemandSegment',
  'liveProgram',
  'book',
  'faculty',
  'subscription',
  'collection',
  'podcast',
  'podcastEpisode',
  'embeddedMedia'
];

export const convertSearchableType = (_type: SearchableType): string | undefined => {
  try {
    const lowerCaseType = _type?.toString()?.toLowerCase() ?? '';
    return ConvertedSearchableType.find(type => type.toLowerCase() === lowerCaseType);
  } catch {
    /* empty */
  }
};

export const getFeedIdentifier = (feed: FilterBlockExtended) => {
  return feed.text || '';
};
